import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import OrderItem from "./OrderItem";
import ConfirmPopup from "./ConfirmPopup";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";

function OrderItems(props) {
  const { orders, setReload } = props;
  const { t } = useTranslation();
  const [rejectProceed, setRejectProceed] = useState(false);
  const [approvalProceed, setApprovalProceed] = useState(false);
  const [orderAction, setOrderAction] = useState({
    action: null,
    quotation: null,
  });
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [reason, setReason] = useState('');
  const [reasonError, setReasonError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const handleCancel = () => {
    setOrderAction({
      action: null,
      quotation: null,
    });
    setApprovalProceed(false);
    setRejectProceed(false);
  };
  const handleProceed = async () => {
    if (rejectProceed && (!reason || reason.trim() === "")) {
      setReasonError("Reason is required.");
      return;
    }
    setLoader(true);
    const res = await API.putWithToken(
      `${ENDPOINTS.QUOTE}/${orderAction.action}/${orderAction.quotation}`,
      rejectProceed
        ? { reason }
        : {}

    );
    console.log("res", res);
    handleCancel();
    if (res?.statusText == "OK") {
      setLoader(false);
      setReload(true);
      setReason('');
    }
  };

  const handleRejectClick = (id) => {
    setOrderAction({
      action: "reject",
      quotation: id,
    });
    setRejectProceed(true);
  };
  const handleApprovalClick = (id) => {
    setOrderAction({
      action: "accept",
      quotation: id,
    });
    setApprovalProceed(true);
  };
  const getStatus = (order) => {
    const status = order.status;
    const today = new Date();
    const deliveryDate = new Date(order.delivery_date);
    let labelDelivered = t("pending_invoice_blossoms");
    //console.log('order?.invoice',order?.invoice)
    if (status == '4' && order?.invoice != undefined) {
      labelDelivered = t("pending_delivery");
      if (today > deliveryDate) {
        labelDelivered = t("delivered");
      }
    }
    let labelOne = t("pending-invoice");
    var statuses = {
      1: labelOne,
      2: t("pending-district-manager-approval"),
      3: t("rejected-by-district-manager"),
      4: labelDelivered,
      6: t("pending-district-manager-approval"),
      7: t("pending-invoice"),
      8: labelDelivered,
      9: t("rejected-by-district-manager"),
      default: t("unknown-order-status"),
    };
    return statuses[status] || statuses["default"];
  };

  const getStatusClass = (order) => {
    const status = order.status;
    let deliveryStatus = 'outstanding';
    var statuses = {
      1: "warning",
      2: "warning",
      3: "danger",
      4: deliveryStatus,
      6: "warning",
      7: "danger",
      8: deliveryStatus,
      9: "danger",
      default: "danger",
    };
    return statuses[status] || statuses["default"];
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (e.target.value.trim() !== "") {
      setReasonError("");
    }
  };

  const handleReasonClick = (item) => {
    setSelectedReason(item.reason);
    setShowPopup(true);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <div className="heightscr- customscroll- order-items">
      <div className="billitem_main">
        {orders &&
          orders.length > 0 &&
          orders.map((item, index) => (
            <OrderItem
              key={index}
              getStatus={getStatus}
              getStatusClass={getStatusClass}
              reject={handleRejectClick}
              approve={handleApprovalClick}
              reasonpopup={handleReasonClick}
              {...item}
            />
          ))}
      </div>
      {rejectProceed && (
        <div className="darkpopup active notification-popup order-confirmation">
          <div className="darkpopup_inner">
            <ConfirmPopup
              content={t('confirm_reject')}
              cancel={handleCancel}
              confirm={handleProceed}
              onReasonChange={handleReasonChange}
              reason={reason}
              reasonError={reasonError}
              showReason={true}
            />
          </div>
        </div>
      )}
      {approvalProceed && (
        <div className="darkpopup active notification-popup order-confirmation">
          <div className="process_popup_inner">
            <ConfirmPopup
              content={t('confirm_order')}
              cancel={handleCancel}
              confirm={handleProceed}
              showReason={false}
            />
          </div>
        </div>
      )}

      {showPopup && (
        <div className="darkpopup active notification-popup">
          <div className="darkpopup_inner">
          <div className="text" style={{ fontWeight: 'bold' }}>
              {t("rejected-note")}
            </div>
            <div className="text">
              {selectedReason || "No reason Provided"}
            </div>
            <div className="yesnobtn">
              <button
                className="whitebtn cancelbtn"
                onClick={handleClose}
              > {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderItems;
